import { cn } from "~/ui-rtk/utils/tailwind-utils"
import AnimatedNumber from "../AnimatedNumber"

type TrendBadgeProps = {
  trend: "up" | "down" | "neutral"
  value: number
  className?: string
}

export default function TrendBadge({
  trend,
  value,
  className,
}: TrendBadgeProps) {
  let trendIcon = "→"
  if (trend === "up") trendIcon = "↑"
  else if (trend === "down") trendIcon = "↓"

  // Guard against NaN, Infinity, or invalid values
  const safeValue = Number.isFinite(value) ? Math.abs(value) : null

  // Don't render if value is invalid
  if (safeValue === null) {
    return null
  }

  return (
    <div
      className={cn(
        "text-xs font-medium inline-flex items-center gap-1 px-2 py-0.5 rounded-full",
        trend === "up" && "text-system-success-400 bg-system-success-900/30",
        trend === "down" && "text-system-error-400 bg-system-error-900/30",
        trend === "neutral" && "text-system-gray-400 bg-system-gray-800/50",
        className,
      )}
    >
      {trendIcon}
      <AnimatedNumber value={safeValue} format="decimal" />%
    </div>
  )
}
